import { Typography, styled } from "@mui/material";

const TypographyStyled = styled(Typography)(() => ({
  fontSize: "20px",
  fontWeight: 500,
  color: "#184c7b",
}));

const TitleUnstyled = ({ title, className, children }) => (
  <TypographyStyled className={className}>
    {typeof title !== "undefined" ? title : children}
  </TypographyStyled>
);

const Title = styled(TitleUnstyled)({});

export default Title;
